const SidebarData = [
  {
    label: "Menu",
    isMainMenu: true,
  },
  // {
  //   label: "Dashboard",
  //   icon: "mdi mdi-home-variant-outline",
  //   url: "/dashboard",
  //   issubMenubadge: true,
  //   bgcolor: "bg-primary",
  //   badgeValue: "3",
  // },
  {
    label: "Terms & Conditions",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/TnC",
  },
  {
    label: "Modal Key Value",
    icon: "mdi mdi-code-braces",
    isHasArrow: true,
    url: "/modal-key-value",
  },
  {
    label: "Privacy Policy",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/privacyPolicy",
  },
  {
    label: "Cookie Policy",
    icon: "mdi mdi-file-document",
    isHasArrow: true,
    url: "/cookiePolicy",
  },
  {
    label: "temp Table",
    icon: "mdi mdi-table",
    isHasArrow: true,
    url: "/tempTable",
  },
  {
    label: "User Badge",
    icon: "mdi mdi-badge-account",
    isHasArrow: true,
    url: "/userBadge",
  },
  {
    label: "Badge",
    icon: "mdi mdi-medal",
    isHasArrow: true,
    url: "/badge",
  },
  {
    label: "Looking For",
    icon: "mdi mdi-eye",
    isHasArrow: true,
    url: "/lookingFor",
  },
  {
    label: "Hotspot Moderation",
    icon: "mdi mdi-map-marker-check",
    isHasArrow: true,
    url: "/hotspotModeration",
  },
  {
    label: "Reported Hotspot",
    icon: "mdi mdi-flag",
    isHasArrow: true,
    url: "/reportedHotspot",
  },
  {
    label: "User Moderation",
    icon: "mdi mdi-account-multiple",
    isHasArrow: true,
    url: "/userModeration",
  },
  {
    label: "Reported Users",
    icon: "mdi mdi-account-alert",
    isHasArrow: true,
    url: "/reportedUsers",
  },
  {
    label: "Reported Broadcast",
    icon: "mdi mdi-broadcast-off",
    isHasArrow: true,
    url: "/reportedBroadcast",
  },
  {
    label: "Pending Broadcasts",
    icon: "mdi mdi-broadcast",
    isHasArrow: true,
    url: "/pendingBroadcasts",
  },
  {
    label: "Business Verification",
    icon: "mdi mdi-domain",
    isHasArrow: true,
    url: "/businessVerification",
  },
  {
    label: "User Phone OTP",
    icon: "mdi mdi-cellphone-key",
    isHasArrow: true,
    url: "/userPhoneOtp",
  },
  {
    label: "User Banner",
    icon: "mdi mdi-image-multiple",
    isHasArrow: true,
    url: "/userBanner",
  },
  {
    label: "Token Status",
    icon: "mdi mdi-token",
    isHasArrow: true,
    url: "/tokenStatus",
  },
  {
    label: "Support",
    icon: "mdi mdi-help-circle",
    isHasArrow: true,
    url: "/support",
  },
  {
    label: "School",
    icon: "mdi mdi-school-outline",
    isHasArrow: true,
    url: "/school",
  },
  {
    label: "Company",
    icon: "mdi mdi-domain",
    isHasArrow: true,
    url: "/company",
  },
  {
    label: "Job",
    icon: "mdi mdi-briefcase-outline",
    isHasArrow: true,
    url: "/job",
  },
  {
    label: "Degree",
    icon: "mdi mdi-file-outline",
    isHasArrow: true,
    url: "/degree",
  },
  {
    label: "FoS",
    icon: "mdi mdi-filter-outline",
    isHasArrow: true,
    url: "/fos",
  },
  {
    label: "Sports",
    icon: "mdi mdi-run-fast",
    isHasArrow: true,
    url: "/sports",
  },
  {
    label: "Interest",
    icon: "mdi mdi-heart-outline",
    subItem: [
      { sublabel: "Interest", link: "/interest" },
      { sublabel: "Group Interest", link: "/group-interest" },
      {
        sublabel: "Interest Group Association",
        link: "/interest-group-association",
      },
    ],
  },
  {
    label: "Skills",
    icon: "mdi mdi-lightbulb-on-outline",
    subItem: [
      { sublabel: "Skills", link: "/skills" },
      { sublabel: "Group Skills", link: "/group-skills" },
      {
        sublabel: "Skills Group Association",
        link: "/skills-group-association",
      },
    ],
  },
  {
    label: "Analytics",
    icon: "mdi mdi-google-analytics",
    subItem: [
      { sublabel: "Looking For Analytics", link: "/lookingForAnalytics" },
      { sublabel: "Gender Analytics", link: "/GenderAnalytics" },
      { sublabel: "Interests Analytics", link: "/InterestGroupAnalytics" },
    ],
  },
];
export default SidebarData;